module.exports = __webpack_public_path__ + "img/12.1724e7d7.jpg";